// extracted by mini-css-extract-plugin
module.exports = {"main-container":"page_main-container__vI0Iu"};